import { REHYDRATE } from 'redux-persist';
import { LOGGED_OUT } from 'actions/types';
export const initialState = {
    isaAllowance: undefined,
};
const reducer = (state = initialState, action) => {
    switch (action?.type) {
        case REHYDRATE: {
            if (action.payload && action.payload.wealth) {
                return {
                    ...state, // initialize new or missing keys, so that we don’t have to declare them as optionals
                    ...action.payload.wealth,
                };
            }
            return state;
        }
        case LOGGED_OUT:
            return initialState;
        case 'GET_POTS_SUCCESS':
            return {
                ...state,
                // keep the current value if the response omits it
                isaAllowance: action.payload.isaAllowance ?? state.isaAllowance,
            };
        case 'GET_ISA_ALLOWANCE_SUCCESS':
            return {
                ...state,
                isaAllowance: action.payload,
            };
        case 'CREATE_POT_SUCCESS':
            return {
                ...state,
                // keep the current value if the response omits it
                isaAllowance: action.payload.isaAllowance ?? state.isaAllowance,
            };
        case 'GET_TRADING_ACCOUNTS_SUCCESS': {
            const isaAccount = action.payload.accounts.find(({ account }) => account.accountType === 'ISA')?.account;
            const isaAllowance = isaAccount?.accountType === 'ISA' ? isaAccount.isaAllowance : undefined;
            return {
                ...state,
                // only the ISA account carries it, so keep the current value otherwise
                isaAllowance: isaAllowance ?? state.isaAllowance,
            };
        }
        default:
            return state;
    }
};
export default reducer;
